import React from 'react';
import { trackLeadEvent, getTrackingUrl } from '../utils/trackingUtils';
export function StickyBar() {
  const handleClick = () => {
    trackLeadEvent();
  };
  const targetUrl = getTrackingUrl('https://nivieorganics.com/pages/mineral-drops');
  return <div className="fixed bottom-0 left-0 right-0 bg-black text-white py-3 px-4 shadow-lg z-50" data-id="element-260">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between" data-id="element-261">
        <p className="text-sm sm:text-base font-medium text-center sm:text-left mb-2 sm:mb-0" data-id="element-262">
          Try #1 Endocrinologist Preferred Supplement for Mineral Support
          Risk-Free
        </p>
        <a href={targetUrl} target="_blank" rel="noopener noreferrer" onClick={handleClick} className="bg-white text-black px-4 py-1.5 rounded font-bold text-sm tracking-wide hover:bg-gray-200 transition-colors whitespace-nowrap" data-id="element-263">
          CHECK AVAILABILITY
        </a>
      </div>
    </div>;
}